import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M4.442 21.75v-5.5h2.5v5.5zm4.962 0V9.475Q8 9.9 7.428 11.004t-.659 2.554h-1.5q.087-2.97 1.88-4.658Q8.943 7.212 12 7.212q2.558 0 3.875-1.045 1.317-1.046 1.375-3.57h1.5q-.03 2.16-1.029 3.677-1 1.517-3.125 2.03V21.75h-1.5v-5.942h-2.192v5.942zM12 5.885a1.78 1.78 0 0 1-1.307-.54 1.78 1.78 0 0 1-.54-1.306q0-.768.54-1.307.54-.54 1.307-.54t1.307.54q.54.54.54 1.307t-.54 1.306q-.54.54-1.307.54" }, null, -1)
  ])))
}
export default { render: render }